module.exports = __webpack_public_path__ + "static/media/78.23777252.png";